import { createSelector } from 'reselect';
import { STANDARD_CATEGORIES, EXPANDED_CATEGORIES } from 'constants/outfits';
import { EXCLUDED_CATEGORY_NAMES } from 'constants/possessions';

import hasAppropriatelyNaturedQualities from './hasAppropriatelyNaturedQualities';

const getCategories = ({ myself: { categories } }) => categories;
const getQualities = ({ myself: { qualities } }) => qualities;

const inputs = [getCategories, getQualities];

const output = (categories, qualities) => categories
  .map((c, i) => ({ ...c, id: i }))
  .filter(c => c.qualities.length)
  .filter(hasThingNaturedQualities({ qualities }))
  .filter(isNotExcluded)
  .filter(isNotAnEquippableCategory);

export default createSelector(inputs, output);

export function hasThingNaturedQualities({ qualities }) {
  // Only return categories that contain Status-natured qualities
  return hasAppropriatelyNaturedQualities('Thing')({ qualities });
}

export function isNotAnEquippableCategory(category) {
  return [...STANDARD_CATEGORIES, ...EXPANDED_CATEGORIES].indexOf(category.name) < 0;
}

export function isNotExcluded(category) {
  return !EXCLUDED_CATEGORY_NAMES.includes(category.name);
}
